import { useHandler } from "@redotech/react-util/hook";
import {
  CustomerTagProvider,
  CustomerTagRecord,
} from "@redotech/redo-common-model-tags-common/customer-tag-record";
import { AddCustomerTagsActionStep } from "@redotech/redo-flows-common/oms/actions";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";
import { PartialWithRequiredType } from ".";
import { CustomerTagsMultiSelect } from "./common/customer-tags-multi-select";

export const CustomerTagInput = memo(function CustomerTagInput({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<AddCustomerTagsActionStep>;
  setStep: (step: PartialWithRequiredType<AddCustomerTagsActionStep>) => void;
}) {
  const { t } = useTranslation();
  const tagIds = useMemo(
    () => (step.tags ?? []).flatMap((tag) => (tag._id ? [tag._id] : [])),
    [step.tags],
  );

  const setSelectedTags = useHandler((tags: CustomerTagRecord[]) => {
    setStep({
      ...step,
      // Name and provider are stored so applying the tag needs no extra lookup.
      tags: tags.map((tag) => ({
        _id: tag._id,
        name: tag.name,
        provider: tag.provider ?? CustomerTagProvider.SHOPIFY,
      })),
    });
  });

  return (
    <Flex dir="column" gap="sm" w="full">
      <CustomerTagsMultiSelect
        setSelectedTags={setSelectedTags}
        tagIds={tagIds}
      />
      <Text fontSize="xs" textColor="secondary">
        {t(
          "Only applies to orders from {{platformName}}. {{brandName}} tags stay in {{brandName}}; {{platformName}} tags are also written back to the customer in {{platformName}}.",
          { platformName: "Shopify", brandName: "Redo" },
        )}
      </Text>
    </Flex>
  );
});
